/* Breadcrumb - Warm-neutral admin breadcrumb aligned to the Buitn Planten palette.
   Updated: replaces gray fallbacks with sage/bosgroen/beige so it matches the unified admin look. */


import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  pageName?: string;
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ pageName, items }: BreadcrumbProps) {
  const navigate = useNavigate();

  const breadcrumbItems = items || (pageName ? [{ label: pageName }] : []);

  return (
    <div className="mb-6">
      <nav>
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          <li>
            <a
              href="/kh-admin"
              className="inline-flex items-center justify-center w-8 h-8 text-[#5a6552] hover:bg-[#e7e1d6]/60 hover:text-[#1e2b22] transition-all rounded-[10px]"
              title="Dashboard"
            >
              <Home className="w-4 h-4" />
            </a>
          </li>
          {breadcrumbItems.map((item, index) => {
            const isLast = index === breadcrumbItems.length - 1;
            return (
              <>
                <li key={`sep-${index}`} className="text-[#cfcac2]">/</li>
                <li key={`item-${index}`}>
                  {item.path && !isLast ? (
                    <button
                      onClick={() => navigate(item.path!)}
                      className="text-[#5a6552] hover:text-[#1e2b22] transition-colors"
                    >
                      {item.label}
                    </button>
                  ) : (
                    <span className={isLast ? 'text-[#1e2b22] font-medium' : 'text-[#5a6552]'}>
                      {item.label}
                    </span>
                  )}
                </li>
              </>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
